import pinia from '@/store/store';
import { store } from '@/store/index';
import { toRefs } from 'vue';
import type { flightFormatItem, flightResponseItem } from '@/model/baseModel';

const piniaStore = store(pinia);
const { getLang } = toRefs(piniaStore);
let carrierAllList: any = piniaStore.getCarrierAll;
function getCityInfo(str: string, airports: any) {
  for (let i = 0, len = airports.length; i < len; i++) {
    if (airports[i].airportCode == str) {
      return airports[i];
    }
  }
}
function getCarrierInfo(str: string) {
  for (let o = 0; o < carrierAllList.length; o++) {
    if (carrierAllList[o].airlineCode2 === str) {
      return {
        ...carrierAllList[o],
        showPrice: 0,
      };
    }
  }
}
console.log(getLang.value);
function formatDuration(duration: number) {
  if (duration < 60) {
    return 0 + ((getLang.value === 'En' || getLang.value === 'Id') ? 'h' : '时') + duration + ((getLang.value === 'En' || getLang.value === 'Id') ? 'm' : '分');
  } else {
    const hour = Math.floor(duration / 60);
    const minutes = duration - hour * 60;
    return hour + ((getLang.value === 'En' || getLang.value === 'Id') ? 'h' : '时') + minutes + ((getLang.value === 'En' || getLang.value === 'Id') ? 'm' : '分');
  }
}
function formatDurationHour(duration: number) {
  if (duration < 60) {
    return 0;
  } else {
    const hour = Math.floor(duration / 60);
    return hour;
  }
}
function formatStops(citys: string, airports: any) {
  if (citys.length == 0) {
    return [];
  }
  const newList = citys.split('/');
  const returnList = [];
  for (let i = 0; i < airports.length; i++) {
    if (newList.indexOf(airports[i].cityCode) != -1) {
      returnList.push(airports[i].cityNameEn);
    }
    if (returnList.length == newList.length) {
      break;
    }
  }
  return returnList;
}

function calculateTime(arrTime: string, depTime: string) {
  let duration = new Date(depTime).getTime() - new Date(arrTime).getTime();
  duration = duration / 60000;
  return formatDuration(duration);
}

function judgeCarrier(carrierCode: any, carrierList: any, price: any) {
  //返回值含义 0-不包含1-包含但要修改价格2-包含并且不需要修改价格、及相关位置

  for (let i = 0; i < carrierList.length; i++) {
    if (carrierCode == carrierList[i].airlineCode2) {
      if (price < carrierList[i].showPrice) {
        return [1, i];
      }
      return [2, i];
    }
  }
  return [0, 0];
}

function judgeConnection(connection: any, connectionList: any, price: any) {
  //返回值含义 0-不包含1-包含但要修改价格2-包含并且不需要修改价格、及相关位置

  for (let i = 0; i < connectionList.length; i++) {
    if (connection == connectionList[i].airportCode) {
      if (price < connectionList[i].showPrice) {
        return [1, i];
      }
      return [2, i];
    }
  }
  return [0, 0];
}

function formatTime(str: any) {
  str = str + '00';
  return str.replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, '$1/$2/$3 $4:$5:$6');
}

export function formatFlight(list: flightResponseItem[], personNum: any, airports: any) {
  carrierAllList = piniaStore.carrierList;
  if (carrierAllList.length == 0) {
    return;
  }

  const newList = JSON.parse(JSON.stringify(list));
  const newResultList: any = [];
  let depSegments;
  let arrSegments;
  let retDepSegments;
  let retArrSegments;
  let durationMin = false;
  let durationMax = false;
  let priceMin = 0; //最便宜的最低价格
  const recommendMin = 0; //推广的最低价格
  let priceMax = 0;
  let fromDurationMin = false;
  let fromDurationMax = false;
  let retDurationMax = false;
  let retDurationMin = false;
  let durationMinPrice = 0; //最快的最低价格
  const stopsList = [0, 0, 0, 0];
  const priceList = [0, 0, 0, 0, 0];
  const depTimeList = [0, 0, 0, 0, 0, 0, 0, 0]; //出发时间
  const arrTimeList = [0, 0, 0, 0, 0, 0, 0, 0]; //出发时间
  const carrierList = []; //航司
  const connectionList: any[] = []; //中转城市
  let depArrCityList: any = []; //出发地到达地集合
  let depMinPrice = 0;

  for (let i = 0, len = newList.length; i < len; i++) {
    newList[i].fromStops = 0;
    newList[i].stops = 0;
    newList[i].retStops = 0;
    newList[i].duration = 0;
    newList[i].durationFrom = 0;
    newList[i].showPrice = 0;
    newList[i].durationRet = 0;
    newList[i].carriers = [];
    newList[i].carriersFrom = [];
    newList[i].carriersRet = [];
    // 去除没有在航司列表出现的航司
    let isContinueShowCarrier = true;
    const {
      childPrice,
      childTax,
      adultPrice,
      adultTax,
      infantPrice,
      infantTax,
      studentPrice,
      studentTax,
      seamanPrice,
      seamanTax,
      laborPrice,
      laborTax
    } = newList[i];
    newList[i].showPrice =
      ((personNum.adultNum > 0 ? (adultPrice + adultTax) * Number(personNum.adultNum) : 0) +
        (personNum.childNum > 0 ? (childPrice + childTax) * Number(personNum.childNum) : 0) +
        (personNum.infantNum > 0 ? (infantPrice + infantTax) * Number(personNum.infantNum) : 0) +
        (personNum.studentNum > 0 ? (studentPrice + studentTax) * Number(personNum.studentNum) : 0) +
        (personNum.seamanNum > 0 ? (seamanPrice + seamanTax) * Number(personNum.seamanNum) : 0) +
        (personNum.laborNum > 0 ? (laborPrice + laborTax) * Number(personNum.laborNum) : 0)) /
      (Number(personNum.adultNum) +
        Number(personNum.childNum) +
        Number(personNum.infantNum) +
        Number(personNum.studentNum) +
        Number(personNum.seamanNum) +
        Number(personNum.laborNum));
    const priceGear = Math.floor(newList[i].showPrice / 5000);
    priceList[priceGear]++;
    for (let j = 0, leng = newList[i].fromSegments.length; j < leng; j++) {

      if (!getCarrierInfo(newList[i].fromSegments[j].carrier)) {
        isContinueShowCarrier = false;
        continue;
      }
      newList[i].fromSegments[j].isTransit = false; //是否中转
      newList[i].fromSegments[j].isTransitTime = ''; //中转时间
      newList[i].fromSegments[j].depTime = formatTime(newList[i].fromSegments[j].depTime);
      newList[i].fromSegments[j].arrTime = formatTime(newList[i].fromSegments[j].arrTime);

      const carrierInfo = getCarrierInfo(newList[i].fromSegments[j].carrier);
      newList[i].duration = newList[i].duration + newList[i].fromSegments[j].duration;
      newList[i].durationFrom =
        newList[i].durationFrom * 1 + newList[i].fromSegments[j].duration * 1;
      if (j > 0) {
        let waitTime =
          new Date(newList[i].fromSegments[j].depTime).getTime() -
          new Date(newList[i].fromSegments[j - 1].arrTime).getTime();
        waitTime = waitTime / 60000;
        newList[i].duration = newList[i].duration * 1 + waitTime * 1;
        newList[i].durationFrom = newList[i].durationFrom * 1 + waitTime * 1;
      }
      carrierInfo.showPrice = newList[i].showPrice;
      if (depMinPrice == 0) {
        depMinPrice = newList[i].showPrice;
      }
      newList[i].fromSegments[j].carrierInfo = carrierInfo;
      newList[i].carriersFrom.push(carrierInfo);
      // 乘机时间
      newList[i].fromSegments[j].showDuration = formatDuration(newList[i].fromSegments[j].duration);
      newList[i].fromSegments[j].showDepCity = getCityInfo(newList[i].fromSegments[j].depAirport, airports);
      newList[i].fromSegments[j].showArrCity = getCityInfo(newList[i].fromSegments[j].arrAirport, airports);
      newList[i].fromSegments[j].showDepTime = newList[i].fromSegments[j].depTime.substr(11, 5);
      newList[i].fromSegments[j].showArrTime = newList[i].fromSegments[j].arrTime.substr(11, 5);
      newList[i].fromSegments[j].showStops = formatStops(newList[i].fromSegments[j].stopCities, airports);
      newList[i].carriers.push(carrierInfo);
      const carrierResult = judgeCarrier(
        newList[i].fromSegments[j].carrier,
        carrierList,
        newList[i].showPrice
      );
      if (carrierResult[0] == 0) {
        carrierList.push(carrierInfo);
      } else if (carrierResult[0] == 1) {
        carrierList[carrierResult[1]].showPrice = newList[i].showPrice;
      }
      if (newList[i].fromSegments[j].stopCities != '') {
        newList[i].stops =
          newList[i].stops + newList[i].fromSegments[j].stopCities.split(',').length;
        newList[i].fromStops =
          newList[i].fromStops + newList[i].fromSegments[j].stopCities.split(',').length;
      }
      if (j > 0) {
        newList[i].fromSegments[j].isTransit = newList[i].fromSegments[j - 1].showArrCity;
        if (!newList[i].fromSegments[j].isTransit) {
          newList[i].fromSegments[j].isTransit = {
            airportCode: newList[i].fromSegments[j].arrAirport,
            airportNameCn: newList[i].fromSegments[j].showArrCity['airportNameCn'],
            airportNameEn: newList[i].fromSegments[j].showArrCity['airportNameEn'],
            airportNameHk: newList[i].fromSegments[j].showArrCity['airportNameHk'],
            airportNamePy: newList[i].fromSegments[j].showArrCity['airportNamePy'],
            cityCode: newList[i].fromSegments[j].showArrCity.cityCode,
            cityNameCn: newList[i].fromSegments[j].showArrCity['cityNameCn'],
            cityNameEn: newList[i].fromSegments[j].showArrCity['cityNameEn'],
            cityNameHk: newList[i].fromSegments[j].showArrCity['cityNameHk'],
            cityNamePy: newList[i].fromSegments[j].showArrCity['cityNamePy'],

            countryCode: newList[i].fromSegments[j].showArrCity.countryCode,
            countryNameCn: newList[i].fromSegments[j].showArrCity.countryNameCn,
            countryNameEn: newList[i].fromSegments[j].showArrCity.countryNameEn,
            countryNameHk: newList[i].fromSegments[j].showArrCity.countryNameHk,
            countryTel: null,
            isCity: newList[i].fromSegments[j].showArrCity.isCity,
            price: newList[i].showPrice
          };
        }
        newList[i].fromSegments[j].isTransit.price = newList[i].showPrice;
        if (newList[i].fromSegments[j].isTransit) {
          if (connectionList.findIndex(
            (item: any) => item.airportCode === newList[i].fromSegments[j].isTransit.airportCode
          ) == -1) {
            connectionList.push({
              ...newList[i].fromSegments[j].isTransit,
              price: newList[i].showPrice
            });
          } else {
            connectionList.forEach((item, ind) => {
              if (newList[i].fromSegments[j].isTransit.airportCode == item.airportCode && item.price > newList[i].showPrice) {
                connectionList[ind].price = newList[i].showPrice;
              }
            });
          }
        }

        // const connectionResult = judgeConnection(
        //   newList[i].fromSegments[j].isTransit.airportCode,
        //   connectionList,
        //   newList[i].showPrice
        // );
        // if (connectionResult[0] == 0) {
        //   connectionList.push(newList[i].fromSegments[j].isTransit);
        // } else if (connectionResult[0] == 1) {
        //   connectionList[i].price = newList[i].showPrice;
        // }
      }
      if (j > 0) {
        newList[i].fromSegments[j].isTransitTime = calculateTime(
          newList[i].fromSegments[j - 1].arrTime,
          newList[i].fromSegments[j].depTime
        );
      }
    }
    if (isContinueShowCarrier) {
      newList[i].fromStops = newList[i].fromStops + (newList[i].fromSegments.length - 1);
      //航程部分信息可在航段循环后直接使用
      depSegments = newList[i].fromSegments[0];
      arrSegments = newList[i].fromSegments[newList[i].fromSegments.length - 1];
      newList[i].depDate = depSegments.depTime.substr(0, 10);
      newList[i].depTime = depSegments.depTime.substr(11, 5);
      newList[i].arrDate = arrSegments.arrTime.substr(0, 10);
      newList[i].arrTime = arrSegments.arrTime.substr(11, 5);
      newList[i].depCityInfo = depSegments.showDepCity;
      newList[i].arrCityInfo = arrSegments.showArrCity;
      newList[i].fromDayPlus = getDateByDays(newList[i].depDate, newList[i].arrDate);

      if (
        depArrCityList.findIndex(
          (item: any) => item.airportCode === newList[i].depCityInfo.airportCode
        ) == -1
      ) {
        if (depMinPrice > newList[i].showPrice) {
          depMinPrice = newList[i].showPrice;
        }
        depArrCityList.push(
          Object.assign(newList[i].depCityInfo, { depMinPrice: depMinPrice, checked: false })
        );
      } else {
        if (depMinPrice > newList[i].showPrice) {
          depMinPrice = newList[i].showPrice;
        }
        depArrCityList[
          depArrCityList.findIndex(
            (item: any) => item.airportCode === newList[i].depCityInfo.airportCode
          )
        ].depMinPrice = depMinPrice;
      }
      if (
        depArrCityList.findIndex(
          (item: any) => item.airportCode === newList[i].arrCityInfo.airportCode
        ) == -1
      ) {
        if (depMinPrice > newList[i].showPrice) {
          depMinPrice = newList[i].showPrice;
        }
        depArrCityList.push(
          Object.assign(newList[i].arrCityInfo, { depMinPrice: depMinPrice, checked: false })
        );
      } else {
        if (depMinPrice > newList[i].showPrice) {
          depMinPrice = newList[i].showPrice;
        }
        depArrCityList[
          depArrCityList.findIndex(
            (item: any) => item.airportCode === newList[i].arrCityInfo.airportCode
          )
        ].depMinPrice = depMinPrice;
      }
    }
    if (isContinueShowCarrier) {
      for (let j = 0, leng = newList[i].retSegments.length; j < leng; j++) {
        if (!getCarrierInfo(newList[i].retSegments[j].carrier)) {
          isContinueShowCarrier = false;
          continue;
        }
        newList[i].retSegments[j].isTransit = false; //是否中转
        newList[i].retSegments[j].isTransitTime = ''; //中转时间
        newList[i].retSegments[j].depTime = formatTime(newList[i].retSegments[j].depTime);
        newList[i].retSegments[j].arrTime = formatTime(newList[i].retSegments[j].arrTime);
        const carrierInfo = getCarrierInfo(newList[i].retSegments[j].carrier);
        newList[i].duration = newList[i].duration * 1 + newList[i].retSegments[j].duration * 1;
        if (j > 0) {
          let waitTime =
            new Date(newList[i].retSegments[j].depTime).getTime() -
            new Date(newList[i].retSegments[j - 1].arrTime).getTime();
          waitTime = waitTime / 60000;
          newList[i].duration = newList[i].duration * 1 + waitTime * 1;
          newList[i].durationRet = newList[i].durationRet * 1 + waitTime * 1;
        }
        newList[i].durationRet = newList[i].durationRet + newList[i].retSegments[j].duration;
        carrierInfo.showPrice = newList[i].showPrice;
        newList[i].retSegments[j].carrierInfo = carrierInfo;
        newList[i].carriersRet.push(carrierInfo);
        newList[i].retSegments[j].showDuration = formatDuration(newList[i].retSegments[j].duration);
        newList[i].retSegments[j].showDepCity = getCityInfo(newList[i].retSegments[j].depAirport, airports);
        newList[i].retSegments[j].showArrCity = getCityInfo(newList[i].retSegments[j].arrAirport, airports);
        newList[i].retSegments[j].showDepTime = newList[i].retSegments[j].depTime.substr(11, 5);
        newList[i].retSegments[j].showArrTime = newList[i].retSegments[j].arrTime.substr(11, 5);
        newList[i].retSegments[j].showStops = formatStops(newList[i].retSegments[j].stopCities, airports);
        newList[i].carriers.push(carrierInfo);
        if (newList[i].retSegments[j].stopCities != '') {
          newList[i].stops = newList[i].stops + newList[i].retSegments[j].stopCities.split(',').length;
          newList[i].retStops =
            newList[i].retStops + newList[i].retSegments[j].stopCities.split(',').length;
        }
        const carrierResult = judgeCarrier(
          newList[i].retSegments[j].carrier,
          carrierList,
          newList[i].showPrice
        );
        if (carrierResult[0] == 0) {
          carrierList.push(carrierInfo);
        } else if (carrierResult[0] == 1) {
          carrierList[carrierResult[1]].showPrice = newList[i].showPrice;
        }
        if (j > 0) {
          newList[i].retSegments[j].isTransit = newList[i].retSegments[j - 1].showArrCity;
          if (!newList[i].retSegments[j].isTransit) {
            newList[i].retSegments[j].isTransit = {
              airportCode: newList[i].retSegments[j].arrAirport,
              airportNameCn: newList[i].retSegments[j].showArrCity['airportNameCn'],
              airportNameEn: newList[i].retSegments[j].showArrCity['airportNameEn'],
              airportNameHk: newList[i].retSegments[j].showArrCity['airportNameHk'],
              airportNamePy: newList[i].retSegments[j].showArrCity['airportNamePy'],
              cityCode: newList[i].retSegments[j].showArrCity.cityCode,
              cityNameCn: newList[i].retSegments[j].showArrCity['cityNameCn'],
              cityNameEn: newList[i].retSegments[j].showArrCity['cityNameEn'],
              cityNameHk: newList[i].retSegments[j].showArrCity['cityNameHk'],
              cityNamePy: newList[i].retSegments[j].showArrCity['cityNamePy'],
              countryCode: newList[i].retSegments[j].showArrCity.countryCode,
              countryNameCn: newList[i].retSegments[j].showArrCity.countryNameCn,
              countryNameEn: newList[i].retSegments[j].showArrCity.countryNameEn,
              countryNameHk: newList[i].retSegments[j].showArrCity.countryNameHk,
              countryTel: null,
              isCity: newList[i].retSegments[j].showArrCity.isCity,
              price: newList[i].showPrice
            };
          }
          newList[i].retSegments[j].isTransit.price = newList[i].showPrice;
          if (newList[i].retSegments[j].isTransit) {
            if (connectionList.findIndex(
              (item: any) => item.airportCode === newList[i].retSegments[j].isTransit.airportCode
            ) == -1) {
              connectionList.push({
                ...newList[i].retSegments[j].isTransit,
                price: newList[i].showPrice
              });
            } else {
              connectionList.forEach((item, ind) => {
                if (item.airportCode == newList[i].retSegments[j].isTransit.airportCode && item.price > newList[i].showPrice) {
                  connectionList[ind].price = newList[i].showPrice;
                }
              });
            }
          }

          // const connectionResult = judgeConnection(
          //   newList[i].retSegments[j].isTransit.airportCode,
          //   connectionList,
          //   newList[i].showPrice
          // );
          // if (connectionResult[0] == 0) {
          //   connectionList.push(newList[i].retSegments[j].isTransit);
          // } else if (connectionResult[0] == 1) {
          //   connectionList[i].price = newList[i].showPrice;
          // }
        }
        if (j > 0) {
          newList[i].retSegments[j].isTransitTime = calculateTime(
            newList[i].retSegments[j - 1].arrTime,
            newList[i].retSegments[j].depTime
          );
        }
      }
    }
    if (isContinueShowCarrier) {
      newList[i].retStops = newList[i].retStops + (newList[i].retSegments.length - 1);
      //返程需要展示的信息
      if (newList[i].retSegments.length > 0) {
        retDepSegments = newList[i].retSegments[0];
        retArrSegments = newList[i].retSegments[newList[i].retSegments.length - 1];
        newList[i].retDepDate = retDepSegments.depTime.substr(0, 10);
        newList[i].retDepTime = retDepSegments.depTime.substr(11, 5);
        newList[i].retArrDate = retArrSegments.arrTime.substr(0, 10);
        newList[i].retArrTime = retArrSegments.arrTime.substr(11, 5);
        newList[i].retDepCityInfo = retDepSegments.showDepCity;
        newList[i].retArrCityInfo = retArrSegments.showArrCity;
        newList[i].retDayPlus = getDateByDays(newList[i].retDepDate, newList[i].retArrDate);
        if (
          depArrCityList.findIndex(
            (item: any) => item.airportCode === newList[i].retDepCityInfo.airportCode
          ) == -1
        ) {
          if (depMinPrice > newList[i].showPrice) {
            depMinPrice = newList[i].showPrice;
          }
          depArrCityList.push(
            Object.assign(newList[i].retDepCityInfo, { depMinPrice: depMinPrice, checked: false })
          );
        } else {
          if (depMinPrice > newList[i].showPrice) {
            depMinPrice = newList[i].showPrice;
          }
          depArrCityList[
            depArrCityList.findIndex(
              (item: any) => item.airportCode === newList[i].retDepCityInfo.airportCode
            )
          ].depMinPrice = depMinPrice;
        }
        if (
          depArrCityList.findIndex(
            (item: any) => item.airportCode === newList[i].retArrCityInfo.airportCode
          ) == -1
        ) {
          if (depMinPrice > newList[i].showPrice) {
            depMinPrice = newList[i].showPrice;
          }
          depArrCityList.push(
            Object.assign(newList[i].retArrCityInfo, { depMinPrice: depMinPrice, checked: false })
          );
        } else {
          if (depMinPrice > newList[i].showPrice) {
            depMinPrice = newList[i].showPrice;
          }
          depArrCityList[
            depArrCityList.findIndex(
              (item: any) => item.airportCode === newList[i].retArrCityInfo.airportCode
            )
          ].depMinPrice = depMinPrice;
        }
      }
      //筛选用数组
      if (!fromDurationMin || fromDurationMin > newList[i].durationFrom) {
        fromDurationMin = newList[i].durationFrom;
      }
      if (!fromDurationMax || fromDurationMax < newList[i].durationFrom) {
        fromDurationMax = newList[i].durationFrom;
      }
      if (!retDurationMin || retDurationMin > newList[i].durationRet) {
        retDurationMin = newList[i].durationRet;
      }
      if (!retDurationMax || retDurationMax < newList[i].durationRet) {
        retDurationMax = newList[i].durationRet;
      }
      if (!durationMin || durationMin > newList[i].duration) {
        durationMin = newList[i].duration;
        durationMinPrice = newList[i].showPrice;
      }
      // if (durationMin && durationMin == newList[i].duration) {
      //   if (!durationMinPrice || durationMinPrice > newList[i].showPrice) {
      //     durationMinPrice = newList[i].showPrice
      //   }
      // }
      if (!durationMax || durationMax < newList[i].duration) {
        durationMax = newList[i].duration;
      }
      // newList[i].showDuration = formatDuration(newList[i].duration)
      newList[i].showFromDuration = formatDuration(newList[i].durationFrom);
      newList[i].showFromHour = formatDurationHour(newList[i].durationFrom);
      newList[i].showRetDuration = formatDuration(newList[i].durationRet);
      newList[i].showRetHour = formatDurationHour(newList[i].durationRet);
      stopsList[newList[i].stops]++;
      const depTimeGear = Math.floor(newList[i].depTime.substr(0, 2) / 3);
      depTimeList[depTimeGear]++;
      const arrTimeGear = Math.floor(newList[i].arrTime.substr(0, 2) / 3);
      arrTimeList[arrTimeGear]++;
    }
    if (isContinueShowCarrier) {
      newResultList.push(newList[i]);
      if (!priceMin || newList[i].showPrice < priceMin) {
        priceMin = newList[i].showPrice;
      }
      if (!priceMax || newList[i].showPrice > priceMax) {
        priceMax = newList[i].showPrice;
      }
    }
  }
  for (let h = 0, depLen = depTimeList.length; h < depLen; h++) {
    depTimeList[h] = Math.round((depTimeList[h] / newResultList.length) * 50);
  }
  for (let h = 0, arrLen = arrTimeList.length; h < arrLen; h++) {
    arrTimeList[h] = Math.round((arrTimeList[h] / newResultList.length) * 50);
  }
  newResultList.sort((a: any, b: any) => {
    return a.showPrice - b.showPrice;
  });
  //价格区间规则-两侧最低最高，按1000进行分隔，即0-1000-2000-3000-400-5000，六个点
  // 柱状图为0-1000-2000-3000-4000-5000共五个统计柱状
  const returnList: flightFormatItem[] = newResultList;

  return {
    durationMin: durationMin,
    durationMinPrice: durationMinPrice,
    durationMax: durationMax,
    priceMin: priceMin,
    priceMax: priceMax,
    fromDurationMin: fromDurationMin,
    fromDurationMax: fromDurationMax,
    retDurationMin: retDurationMin,
    retDurationMax: retDurationMax,
    flightList: returnList,
    priceList: priceList,
    carrierList: carrierList,
    stopsList: stopsList,
    depTimeList: depTimeList,
    arrTimeList: arrTimeList,
    connectionList: connectionList,
    depArrCityList: depArrCityList
  };
}

export function formatCity(list: any) {
  for (let i = 0; i < list[1].length; i++) {
    for (let j = 0; j < list[0].length; j++) {
      if (list[1][i].cityCode == list[0][j].cityCode) {
        if (!list[0][j].airportList) {
          list[0][j].airportList = [];
        }
        list[0][j].airportList.push(list[1][i]);
        break;
      }
    }
  }
  return list[0];
}

export function formatCityAll(list: any) {
  const countryList: any[] = [];
  const cityListObj: any = {};
  const cityListAirport: any[] = [];
  const airportListArr: any[] = [];
  for (let i = 0; i < list.length; i++) {
    let inCountryList = false;
    //循环判断是否在国家列表中
    for (let j = 0; j < countryList.length; j++) {
      if (countryList[j].countryCode == list[i].countryCode) {
        inCountryList = true;
      }
    }
    if (!inCountryList && list[i].countryCode) {
      countryList.push({
        countryCode: list[i].countryCode,
        countryNameCn: list[i].countryNameCn,
        countryNameEn: list[i].countryNameEn,
        countryNameHk: list[i].countryNameHk
      });
    }

    let inCityListAirport = false;
    for (let j = 0; j < cityListAirport.length; j++) {
      if (list[i].cityCode == cityListAirport[j].cityCode) {
        inCityListAirport = true;
        cityListAirport[j].airportList.push(list[i]);
        break;
      }
    }
    if (!inCityListAirport) {
      cityListAirport.push({
        cityCode: list[i].cityCode,
        cityNameCn: list[i].cityNameCn,
        cityNameEn: list[i].cityNameEn,
        cityNameHk: list[i].cityNameHk,
        cityNamePy: list[i].cityNamePy,
        airportList: [list[i]]
      });
    }

    if (!inCityListAirport) {
      cityListObj[list[i].cityCode] = {
        cityCode: list[i].cityCode,
        cityNameCn: list[i].cityNameCn,
        cityNameEn: list[i].cityNameEn,
        cityNameHk: list[i].cityNameHk,
        cityNamePy: list[i].cityNamePy
      };
      // cityList.push({
      //   cityCode: list[i].cityCode,
      //   cityNameCn: list[i].cityNameCn,
      //   cityNameEn: list[i].cityNameEn,
      //   cityNameHk: list[i].cityNameHk,
      //   cityNamePy: list[i].cityNamePy
      // })
    }
  }
  return {
    cityListObj,
    countryList,
    cityListAirport,
    airportListArr
  };
}
function getDateByDays(startDate: any, endDdate: any) {
  const d1 = Date.parse(new Date(startDate));
  const d2 = Date.parse(new Date(endDdate));
  // 时间戳相减 / 天数
  const day = parseInt((d2 - d1) / (1000 * 60 * 60 * 24));
  return day;
}
function newPsgItem(type: number) {
  return {
    ageType: type,
    birthday: '',
    birthdayError: false,
    gender: 'M',
    familyName: '',
    familyNameError: false,
    middleName: '',
    givenName: '',
    givenNameError: false,
    cardType: '',
    cardTypeError: false,
    cardNum: '',
    cardNumError: false,
    cardIssuePlace: '',
    cardIssuePlaceError: false,
    cardExpired: '',
    cardExpiredError: false,
    nationality: '',
    mobile: '',
    mobileError: false,
    airlineCode: '',
    airlineCardNo: '',
    showOtherEdit: false
  };
}

export function getNewPsgList(psgNumInfo: any) {
  const returnList = [];
  for (let i = 0; i < psgNumInfo.adultNum; i++) {
    returnList.push(newPsgItem(0));
  }
  for (let i = 0; i < psgNumInfo.childNum; i++) {
    returnList.push(newPsgItem(1));
  }
  for (let i = 0; i < psgNumInfo.infantNum; i++) {
    returnList.push(newPsgItem(2));
  }
  for (let i = 0; i < psgNumInfo.studentNum; i++) {
    returnList.push(newPsgItem(3));
  }
  for (let i = 0; i < psgNumInfo.helperNum; i++) {
    returnList.push(newPsgItem(5));
  }
  for (let i = 0; i < psgNumInfo.seamenNum; i++) {
    returnList.push(newPsgItem(4));
  }
  return returnList;
}
